import HttpService from '../utility/httpService';
class itemStockService {

    async getById(id) {
        const response = await HttpService.get("/Admin/CMS_ItemStock/ItemStockById?id=" + id);
        return response;
    }

    async getLookups() {
        const response = await HttpService.get("/Admin/CMS_Lookups/ItemStockLookup");
        return response;
    }

    async create(data) {
        const response = await HttpService.post("/Admin/CMS_ItemStock/itemStockAdd", data);
        return response;
    }

    async update(data) {
        const response = await HttpService.put("/Admin/CMS_ItemStock/itemStockUpdate", data);
        return response;
    }

    async delete(id) {
        const response = await HttpService.delete("/Admin/CMS_ItemStock/itemStockDelete?id=" + id);
        return response;
    }
}

export default new itemStockService();